<template>
  <div>
    <card class="w-100">
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  default-expand-all
                  row-key="menu_seq"
                  ref="authorityTable"
                  style="width: 100%; margin-bottom: 10px"
                  :data="$store.state.settingsAuthority.menus"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="name"
            label="메뉴명">
          </el-table-column>
          <el-table-column
            label="관리자">
            <template slot-scope="scope">
              <el-switch :id="'admin:' + scope.row.menu_seq"
                         :value="'admin:' + scope.row.menu_seq + ':' + scope.row.admin" @change="switchChange"
                         :active-value="'admin:' + scope.row.menu_seq + ':1'"
                         :inactive-value="'admin:' + scope.row.menu_seq  + ':0'"></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="광고주">
            <template slot-scope="scope">
              <el-switch :id="'advertiser:' + scope.row.menu_seq"
                         :value="'advertiser:' + scope.row.menu_seq + ':' + scope.row.advertiser" @change="switchChange"
                         :active-value="'advertiser:' + scope.row.menu_seq + ':1'"
                         :inactive-value="'advertiser:' + scope.row.menu_seq  + ':0'"></el-switch>
              <el-button v-if="scope.row.column_set && scope.row.advertiser" style="margin-left: 5px" size="mini"
                         type="primary" v-on:click="showModal('ADVERTISER', scope.row.filter_path)">컬럼설정
              </el-button>
            </template>
            <template slot="header" slot-scope="scope">
              <el-button size="mini" type="primary" @click="setAuth('ADVERTISER')">광고주 설정</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="이마트 본사">
            <template slot-scope="scope">
              <el-switch :id="'manager:' + scope.row.menu_seq"
                         :value="'manager:' + scope.row.menu_seq + ':' + scope.row.manager" @change="switchChange"
                         :active-value="'manager:' + scope.row.menu_seq + ':1'"
                         :inactive-value="'manager:' + scope.row.menu_seq  + ':0'"></el-switch>
              <el-button v-if="scope.row.column_set && scope.row.manager" style="margin-left: 5px" size="mini"
                         type="primary" v-on:click="showModal('MANAGER', scope.row.filter_path)">컬럼설정
              </el-button>
            </template>
            <template slot="header" slot-scope="scope">
              <el-button size="mini" type="primary" @click="setAuth('MANAGER')">이마트 본사 설정</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="이마트 점포">
            <template slot-scope="scope">
              <el-switch :id="'emart:' + scope.row.menu_seq"
                         :value="'emart:' + scope.row.menu_seq + ':' + scope.row.emart" @change="switchChange"
                         :active-value="'emart:' + scope.row.menu_seq + ':1'"
                         :inactive-value="'emart:' + scope.row.menu_seq  + ':0'"></el-switch>
              <el-button v-if="scope.row.column_set && scope.row.emart" style="margin-left: 5px" size="mini"
                         type="primary" v-on:click="showModal('EMART', scope.row.filter_path)">컬럼설정
              </el-button>
            </template>
            <template slot="header" slot-scope="scope">
              <el-button size="mini" type="primary" @click="setAuth('EMART')">이마트 점포 설정</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="시공사">
            <template slot-scope="scope">
              <el-switch :id="'builder:' + scope.row.menu_seq"
                         :value="'builder:' + scope.row.menu_seq + ':' + scope.row.builder" @change="switchChange"
                         :active-value="'builder:' + scope.row.menu_seq + ':1'"
                         :inactive-value="'builder:' + scope.row.menu_seq  + ':0'"></el-switch>
              <el-button v-if="scope.row.column_set && scope.row.builder" style="margin-left: 5px" size="mini"
                         type="primary" v-on:click="showModal('BUILDER', scope.row.filter_path)">컬럼설정
              </el-button>
            </template>
            <template slot="header" slot-scope="scope">
              <el-button size="mini" type="primary" @click="setAuth('BUILDER')">시공사 설정</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="광고대행사">
            <template slot-scope="scope">
              <el-switch :id="'agent:' + scope.row.menu_seq"
                         :value="'agent:' + scope.row.menu_seq + ':' + scope.row.agent" @change="switchChange"
                         :active-value="'agent:' + scope.row.menu_seq + ':1'"
                         :inactive-value="'agent:' + scope.row.menu_seq  + ':0'"></el-switch>
              <el-button v-if="scope.row.column_set && scope.row.agent" style="margin-left: 5px" size="mini"
                         type="primary" v-on:click="showModal('AGENT', scope.row.filter_path)">컬럼설정
              </el-button>
            </template>
            <template slot="header" slot-scope="scope">
              <el-button size="mini" type="primary" @click="setAuth('AGENT')">광고대행사 설정</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </card>

    <column-selector-modal ref="columnSelectorModal" :page-type="pageType"
                           v-on:setColumn="setColumn"></column-selector-modal>
  </div>
</template>

<script>

  import Vue from 'vue'
  import {Table, TableColumn, Row, Col, Switch, Button} from 'element-ui'
  import ColumnSelectorModal from "../Common/ColumnSelectorModal";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Switch)
  Vue.use(Button)

  export default {
    name: "SettingsAuthority",
    created: function () {
      this.$store.dispatch('common/setMenuTitle', "권한 관리");
      this.changePage();
    },
    components: {
      ColumnSelectorModal,
    },
    updated: function () {
      this.$refs.authorityTable.doLayout();
    },
    methods: {
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      changePage() {
        this.$store.dispatch('settingsAuthority/findAll');
      },
      switchChange(value) {
        let values = value.split(":");
        let param = {
          menuSeq: values[1],
          roleCode: values[0].toUpperCase()
        };
        if (values[2] === "1") {
          this.$store.dispatch('settingsAuthority/createAuthority', param);
        } else {
          this.$store.dispatch('settingsAuthority/deleteAuthority', param);
        }
      },
      // 대상 확인창 열기/닫기
      showModal(roleCode, path) {
        this.pageType = path;
        this.$refs.columnSelectorModal.findAllByUserIdAndPageTypeParam(roleCode, this.pageType);
        this.$refs.columnSelectorModal.show();
      },
      // 컬럼선택 완료
      setColumn() {
        // this.$refs.advertisementList.findAllByUserIdAndPageType(this.pageType);
        // this.showModal(false);
      },
      // 컬럼선택 창에서 컬럼설정 다시 조회
      updateColumn() {
        // this.$refs.columnSelectorModal.findAllByUserIdAndPageType();
      },
      setAuth(roleCode) {
        Vue.router.push({name: 'SettingsRoleAuth', params: {roleCode : roleCode}});
      }
    },
    data() {
      return {
        pageType: '',
      }
    }
  }
</script>

<style scoped>

</style>
